import logo from './logo.svg';

import HeroSection from './screens/FirstScreen';
import SecondScreen from './screens/SecondScreen';
import AboutAvi from './components/me/Me';
import { WhoFitsSection } from './components/fit/WhoFits';
import { FAQSection } from './screens/ThirdScreen';
import ByMe from './components/ByMe/ByMe';
import NavBarNew from './components/CourseNav/NavBarNew';
import FloatingButton from './components/FloatButton/FloatButton';
import FirstScreen from './screens/FirstScreenNew';
import PrivacyPolicy from './privacy/Privacy';

const Wrapper =()=> {
  return <>
  <NavBarNew/>
  {/* <HeroSection/> */}
  <FirstScreen/>
  <SecondScreen/>
  <AboutAvi/>
  <WhoFitsSection/>

  <FAQSection/>
  <FloatingButton/>
  <PrivacyPolicy/>
  <ByMe/>
  </>
}

export default Wrapper ;